import React, {Component} from 'react';
import common from './../../../common';

class Welcome extends Component {
    componentDidMount() {
        let guid = common.getGUID();
        let objCookie = common.getLocalStorage('objWelcomeCardDisplayed');
        if (!objCookie) {
            objCookie = {};
        }
        objCookie[guid] = true;
        common.setLocalStorage('objWelcomeCardDisplayed', objCookie);
    }

    onClickGotIt = (guid) => {
        let objCookie = common.getLocalStorage('objWelcomeCardDisplayed');
        if (!objCookie) {
            objCookie = {};
        }
        objCookie[guid] = true;
        common.setLocalStorage('objWelcomeCardDisplayed', objCookie);
        this.props.updateWelcomeCardSeenStatus(true);
    };

    componentWillUnmount() {
    }

    render() {
        let trans = this.props.trans;
        let guid = common.getGUID();
        let isShownWelcomeFirstTime = this.props.isShownWelcomeFirstTime;
        // let objWelcomeCardDisplayed = common.getLocalStorage('objWelcomeCardDisplayed');
        if (!isShownWelcomeFirstTime) {
            return <div className="si-card si-welcome-card">
                <div className="si-main-text-block">
                    <div className="text-block">
                        <div className="si-text-title">{trans.wcHeading}</div>
                        <div className="si-text-descp">{trans.wcMessage}</div>
                    </div>
                    <div className="button-block">
                        <div className="si-btn btn-sm" onClick={() => this.onClickGotIt(guid)}>{trans.wcGotIt}</div>
                        <div className="si-btn btn-sm">{trans.wcGameRule}</div>
                    </div>
                </div>
            </div>
        }
        else {
            return null;
        }
    }
}

export default Welcome;


// WEBPACK FOOTER //
// ./src/components/home/cards/Welcome.js